import { BasicCommand } from "../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../common/services/cqs/IPrimaryKey";

export class AddManuelltDestineringsalternativCommand extends BasicCommand<AddManuelltDestineringsalternativCommand> {
    get primaryKey(): IPrimaryKey<AddManuelltDestineringsalternativCommand> {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    handelssortimentId: number;
    mottagningsplatsId: number;
    destineringsursprung: number;
    egenskapskodX: boolean;
    overstyrdAvlastningsplats: string;
    foradlatHandelssortimentId: number;
    inmatningshandelssortimentId?: number;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "AddManuelltDestineringsalternativCommand";
    constructor(arbetsorderId: number,
        handelssortimentId: number,
        mottagningsplatsId: number,
        destineringsursprung: number,
        egenskapskodX: boolean,
        overstyrdAvlastningsplats: string,
        foradlatHandelssortimentId: number,
        inmatningshandelssortimentId?: number) {
        super(AddManuelltDestineringsalternativCommand.$type, "Arbetsorder", CommandType.Replace);
        this.arbetsorderId = arbetsorderId;
        this.handelssortimentId = handelssortimentId;
        this.mottagningsplatsId = mottagningsplatsId;
        this.destineringsursprung = destineringsursprung;
        this.egenskapskodX = egenskapskodX;
        this.overstyrdAvlastningsplats = overstyrdAvlastningsplats;
        this.foradlatHandelssortimentId = foradlatHandelssortimentId;
        this.inmatningshandelssortimentId = inmatningshandelssortimentId;
    }
}
